import React from "react";
import { ButtonGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  TextInput,
  SnackMsg,
  ConfirmationPopUp,
  PrimaryButton,
  SecondaryButton,
  ToggleButton,
  CustomCheckbox,
  UploadSuccessMsg,
  CustomDropdown,
  CustomRadioButton,
  SessionExpiredModal,
  CustomBreadcrumb,
} from "../../components";
import { ApiService } from "../../utils/ApiService";
import { uploadStatusDateFormat } from "../../utils/Helper";
import Skeleton from "@mui/material/Skeleton";
import { Typography } from "@mui/material";
import { API_URL, ADMIN_TYPE } from "../../utils/Constants";
import { StudentConfigStyled } from "./styled";
import {
  STUDENT_CONFIG_CONSTANTS,
  DISABLE_GRADE_HEADER,
  DISABLE_GRADE_BODY,
  ENABLE_GRADE_BODY,
  ENABLE_GRADE_HEADER,
} from "../../config/constants";
import { ROUTES } from "../../config/routes";
import { colors } from "../../config/colors";
import { BORDER_PRIMARY, TEXT_ALIGN_LEFT, TEXT_ALIGN_RIGHT } from "../../config/styles";
import { InfoIconLogo, PrimarySuccessLogo } from "../../assets/icons";

const getFilteredMerchantDetails = (resp) => ({
  address1: resp.body.merchantDetails?.address1 || "",
  primaryContactFirstName:
    resp.body.merchantDetails?.primaryContactFirstName || "",
  primaryLegalName: resp.body.merchantDetails?.primaryLegalName || "",
  countryCode: resp.body.merchantDetails?.countryCode || "",
  primaryWebsiteURL: resp.body.merchantDetails?.primaryWebsiteURL || "",
  primaryTradeName: resp.body.merchantDetails?.primaryTradeName || "",
});

const getFilteredConvienceFees = (resp) => ({
  enabled: resp.body.convenienceFeeConfig
    ? resp.body.convenienceFeeConfig.enabled
    : true,
  value: resp.body.convenienceFeeConfig
    ? resp.body.convenienceFeeConfig.value
    : "0",
  feeType: resp.body.convenienceFeeConfig
    ? resp.body.convenienceFeeConfig.feeType
    : "FIXED",
  maximumAmount: resp.body.convenienceFeeConfig
    ? resp.body.convenienceFeeConfig.maximumAmount
    : "",
});

const getFilteredCheckoutConfig = (resp) => ({
  enabled: resp.body.webCheckoutConfig
    ? resp.body.webCheckoutConfig.enabled
    : false,
  paymentMethods: resp.body.webCheckoutConfig
    ? resp.body.webCheckoutConfig.paymentMethods
    : [],
  systemId: resp.body.webCheckoutConfig
    ? resp.body.webCheckoutConfig.systemId
    : "",
  webhookURL: resp.body.webCheckoutConfig
    ? resp.body.webCheckoutConfig.webhookURL
    : "",
  ottChallengeEnabled: resp.body.webCheckoutConfig
    ? resp.body.webCheckoutConfig.ottChallengeEnabled
    : false,
  ottChallengeSalt: resp.body.webCheckoutConfig
    ? resp.body.webCheckoutConfig.ottChallengeSalt
    : "",
});

const getFilteredOauthConfig = (resp) => ({
    enabled: resp.body.oauthConfig
    ? resp.body.oauthConfig.enabled
    : false,
  clientId: resp.body.oauthConfig
    ? resp.body.oauthConfig.clientId
    : "",
  clientSecret: resp.body.oauthConfig
    ? resp.body.oauthConfig.clientSecret
    : "",
  allowedScope: resp.body.oauthConfig
    ? resp.body.oauthConfig.allowedScope
    : "",
});

const getNewState = ({ resp, eppConfigs, filteredMerchantDetails, filteredConvenienceFeeConfig, filteredCheckoutConfig, filteredOauthConfig }) => ({
  selectedMerchantType: resp.body.merchantType,
  secure3dEnabled: resp.body.secure3dEnabled,
  isCheckedOTP: resp.body.otpRequired,
  outstandingFee: resp.body.outstandingFee,
  updateOutstandingFeeBalance: resp.body.updateOutstandingFeeBalance,
  schoolDataProvided: resp.body.schoolDataProvided,
  paymentGateway: resp.body.paymentGateway,
  eppConfigs: eppConfigs,
  merchantDetails: filteredMerchantDetails,
  convenienceFeeConfig: filteredConvenienceFeeConfig,
  checkoutConfig: filteredCheckoutConfig,
  oauthConfig: filteredOauthConfig,
  appleMechantIdMpgs:
    (resp.body.mpgsConfig && resp.body.mpgsConfig.appleMechantIdMpgs) ||
    "",
  merchantIdMpgs:
    (resp.body.mpgsConfig && resp.body.mpgsConfig.mpgsId) || "",
  merchantOid:
    (resp.body.mpgsConfig && resp.body.mpgsConfig.merchantOid) || "",
  username:
    (resp.body.mpgsConfig && resp.body.mpgsConfig.accountName) || "",
  password: (resp.body.mpgsConfig && resp.body.mpgsConfig.apiKey) || "",

  accessCode:
    (resp.body.payFortConfig && resp.body.payFortConfig.accessCode) ||
    "",
  merchantIdentifier:
    (resp.body.payFortConfig &&
      resp.body.payFortConfig.merchantIdentifier) ||
    "",
  shaRequestPhrase:
    (resp.body.payFortConfig &&
      resp.body.payFortConfig.shaRequestPhrase) ||
    "",
  shaResponsePhrase:
    (resp.body.payFortConfig &&
      resp.body.payFortConfig.shaResponsePhrase) ||
    "",
  hashingFunction:
    (resp.body.payFortConfig &&
      resp.body.payFortConfig.hashingFunction) ||
    "SHA256",

  showMpgs: resp.body.paymentGateway === "MPGS",
  isGradeUpdate:
    resp.body.studentGradeUpdate &&
    resp.body.studentGradeUpdate.gradeUpdateEventEnum ===
    "GRADE_UPDATE_ACTIVE",
  gradeRequestedBy:
    (resp.body.studentGradeUpdate &&
      resp.body.studentGradeUpdate.requestedBy) ||
    "",
  gradeRequestCreatedAt:
    (resp.body.studentGradeUpdate &&
      resp.body.studentGradeUpdate.createdAt) ||
    "",
});
const MESSAGE_MAX_LEN = 924;

class StudentAppConfig extends React.Component {
  constructor(props) {
    super(props);
    this.adminType = localStorage.getItem("role");
    this.snackMsg = {
      configFailure: STUDENT_CONFIG_CONSTANTS.CONFIG_FAILURE,
      configSuccess: STUDENT_CONFIG_CONSTANTS.CONNFIG_SUCCESS,
      gradeEnabled: STUDENT_CONFIG_CONSTANTS.GRADE_ENABLED,
      gradeDisabled: STUDENT_CONFIG_CONSTANTS.GRADE_DISABLED,
    };
    this.paymentGatewayTypes = ["", "MPGS", "PAYFORT"];
    this.state = {
      showSnack: false,
      snackMsg: "",
      isFetching: true,
      schoolDataProvided: true,
      isCheckedFee: false,
      isCheckedOTP: false,
      configUpdateSuccess: false,
      enable: "disabled",
      showSchoolAdmin: false,
      showMpgs: true,
      secure3dEnabled: false,
      paymentGateway: "",
      accessCode: "",
      merchantIdentifier: "",
      shaRequestPhrase: "",
      shaResponsePhrase: "",
      hashingFunction: "SHA256",
      merchantIdMpgs: "",
      appleMechantIdMpgs: "",
      merchantOid: "",
      username: "",
      password: "",
      sessionExpired: false,
      outstandingFee: false,
      updateOutstandingFeeBalance: false,
      partialPaymentAllowed: false,
      isSalesAdmin: false,
      isSaving: false,
      allCriteria: false,
      firstName: false,
      lastName: false,
      phoneNumber: false,
      parentID: false,
      studentID: false,
      emailID1: false,

      isGradeUpdate: false,
      gradeRequestedBy: "",
      gradeRequestCreatedAt: "",
      showConfirmation: false,
      DisableOutstandingFee: false,

      isMerchantFetching: true,
      merchantTypes: [],
      convenienceFeeTypes: ["", "FIXED", "PERCENTAGE"],
      selectedMerchantType: "SCHOOL",
      eppConfigs: {},
      merchantDetails: {
        address1: "",
        primaryContactFirstName: "",
        primaryLegalName: "",
        countryCode: "",
        primaryWebsiteURL: "",
        primaryTradeName: "",
      },
      convenienceFeeConfig: {
        enabled: false,
        value: "",
        feeType: "",
        maximumAmount: "",
      },
      checkoutConfig: {
      enabled: false,
      systemId: "",
      paymentMethods: [],
      webhookURL: "",
      ottChallengeEnabled: false,
      ottChallengeSalt: "",
      },
      oauthConfig : {
      enabled: false,
      clientId: "",
      clientSecret: "",
      allowedScope:"",
      },
      checkoutConfigPaymentypes: ["CARDS", "APPLE PAY", "GOOGLE PAY", "ANI"],
    };

    this.handlePaymentChange = this.handlePaymentChange.bind(this);
    this.handlePaymentConfig = this.handlePaymentConfig.bind(this);
    this.handleSession = this.handleSession.bind(this);
  }

  componentDidMount() {
    let roleData = localStorage.getItem("role");
    if (roleData === ADMIN_TYPE.SCHOOLADMIN) {
      this.setState({ showSchoolAdmin: true });
    }
    if (roleData === ADMIN_TYPE.SALESADMIN) {
      this.setState({ isSalesAdmin: true });
    }
    this.fetchConfig();
    this.fetchMerchantTypes();
  }

  handleSession = (resp) => {
    if (
      (resp.error != undefined && resp.error.status_code === 401) ||
      resp.status === "403" ||
      (resp.status.internalMessage != null &&
        resp.status.internalMessage.includes("403"))
    ) {
      this.setState({ sessionExpired: true });
      return;
    }
  }

  fetchConfig = async () => {
    try {
      let merchantIdGlobal = localStorage.getItem("globalMerchantId");
      if (this.adminType === ADMIN_TYPE.SCHOOLADMIN)
        merchantIdGlobal = localStorage.getItem("schoolAdminMerchantId");

      let url = API_URL.MERCHANT + "/" + merchantIdGlobal;
      const resp = await ApiService.getRequest(url);
      this.handleSession(resp);
      if (resp.body) {
        const eppConfigs = this.preprocessEppDetails(resp.body?.eppDetailsList);

        const filteredMerchantDetails = getFilteredMerchantDetails(resp);

        const filteredConvenienceFeeConfig = getFilteredConvienceFees(resp);

        const filteredCheckoutConfig = getFilteredCheckoutConfig(resp);
        const filteredOauthConfig = getFilteredOauthConfig(resp);
        const newState = getNewState({ resp, eppConfigs, filteredMerchantDetails, filteredConvenienceFeeConfig, filteredCheckoutConfig, filteredOauthConfig });
        let criteria = {};
        if (resp.body.searchParameters) {
          resp.body.searchParameters.forEach(
            (obj) => (criteria[obj.id] = obj.enabled)
          );
        }
        const allValue =
          criteria.firstName &&
          criteria.lastName &&
          criteria.phoneNumber &&
          criteria.parentID &&
          criteria.studentID &&
          criteria.emailID1;
        this.setState({
          ...newState,
          ...criteria,
          allCriteria: allValue,
          isFetching: false,
          partialPaymentAllowed: resp.body.partialPaymentAllowed,
        });
      }
    } catch (err) {
      console.error(err)
     }
  };

  preprocessEppDetails = (eppDetailsList) => {
    const eppConfigs = {};
    eppDetailsList &&
      eppDetailsList.forEach((epp) => {
        if (epp.eppProvider) {
          eppConfigs[epp.eppProvider] = {
            status: epp.status,
            enabled: epp.eppEnabled,
          };
        }
      });
    return eppConfigs;
  };

  fetchMerchantTypes = async () => {
    try {
      let url = API_URL.MERCHANT_TYPES;
      const resp = await ApiService.getRequest(url);
      if (
        (resp.error != undefined && resp.error.status_code === 401) ||
        resp.status === "403" ||
        (resp.status.internalMessage != null &&
          resp.status.internalMessage.includes("403"))
      ) {
        this.setState({ sessionExpired: true });
        return;
      }
      if (resp.body) {
        let types = resp.body.map((item) => item.type);
        types.unshift("");
        this.setState({
          isMerchantFetching: false,
          merchantTypes: types,
        });
      }
    } catch (err) {
      console.error(err)
    }
  };

  sessionExpiredClose = () => {
    this.setState({ sessionExpired: false });
  };

  onSaveStudentConfig = async (e) => {
    if (this.state.convenienceFeeConfig?.value < 0) {
      alert(STUDENT_CONFIG_CONSTANTS.CONVIENCE_FEE_LESSER);
      return;
    }
    if (this.state.convenienceFeeConfig?.feeType == "PERCENTAGE") {
      if (this.state.convenienceFeeConfig?.maximumAmount < 0) {
        alert(STUDENT_CONFIG_CONSTANTS.CONVIENCE_FEE_GREATER);
        return;
      }
    }

    try {
      this.setState({ isSaving: true });
      const errors = this.validateMerchantDetails();
      if (errors.length > 0) {
        alert("Validation errors:\n" + errors.join("\n"));
        this.setState({ isSaving: false });
        return;
      }
      const merchantIdGlobal = localStorage.getItem("globalMerchantId");
      const payload = {
        id: merchantIdGlobal,
        merchantId: merchantIdGlobal,
        secure3dEnabled: this.state.secure3dEnabled,
        outstandingFee: this.state.outstandingFee,
        partialPaymentAllowed: this.state.partialPaymentAllowed,
        updateOutstandingFeeBalance: this.state.updateOutstandingFeeBalance,
        otpRequired: this.state.isCheckedOTP,
        schoolDataProvided: this.state.schoolDataProvided,
        paymentGateway: this.state.paymentGateway,
        mpgsConfig: {
          appleMechantIdMpgs: this.state.appleMechantIdMpgs,
          mpgsId: this.state.merchantIdMpgs,
          accountName: this.state.username,
          apiKey: this.state.password,
          merchantOid: this.state.merchantOid,
        },
        payFortConfig: {
          accessCode: this.state.accessCode,
          merchantIdentifier: this.state.merchantIdentifier,
          shaRequestPhrase: this.state.shaRequestPhrase,
          shaResponsePhrase: this.state.shaResponsePhrase,
          hashingFunction: this.state.hashingFunction,
        },
        searchParameters: [
          {
            id: "firstName",
            label: "First Name",
            enabled: this.state.firstName,
          },
          { id: "lastName", label: "Last Name", enabled: this.state.lastName },
          {
            id: "phoneNumber",
            label: "Phone Number",
            enabled: this.state.phoneNumber,
          },
          { id: "parentID", label: "Parent ID", enabled: this.state.parentID },
          {
            id: "studentID",
            label: "Student ID",
            enabled: this.state.studentID,
          },
          { id: "emailID1", label: "Email ID", enabled: this.state.emailID1 },
        ],
        studentGradeUpdate: {
          gradeUpdateEventEnum: this.state.isGradeUpdate
            ? "GRADE_UPDATE_ACTIVE"
            : "GRADE_UPDATE_ROLLBACK",
          requestedBy: localStorage.getItem("firstName"),
        },
        merchantType: this.state.selectedMerchantType,
        merchantDetails: this.state.merchantDetails,
        convenienceFeeConfig: this.state.convenienceFeeConfig,
        webCheckoutConfig: this.state.checkoutConfig,
        oauthConfig: this.state.oauthConfig,
        eppDetailsList: this.state?.eppConfigs
          ? Object.keys(this.state.eppConfigs).map((provider) => ({
            eppProvider: provider,
            status: this.state.eppConfigs[provider].status,
            eppEnabled: this.state.eppConfigs[provider].enabled,
          }))
          : {},
      };

      const resp = await ApiService.putRequest(API_URL.MERCHANT, payload);
      if (
        (resp.error != undefined && resp.error.status_code === 401) ||
        resp.status === "403" ||
        (resp.status.internalMessage != null &&
          resp.status.internalMessage.includes("403"))
      ) {
        this.setState({
          sessionExpired: true,
          isSaving: false,
          showConfirmation: false,
        });
        return;
      }
      if (resp.status.code == "Y") {
        this.setState({
          showSnack: true,
          isSaving: false,
          showConfirmation: false,
        });
      } else {
        this.setState({
          showSnack: true,
          snackMsg: this.snackMsg.configFailure,
          isSaving: false,
          showConfirmation: false,
        });
      }
    } catch (err) { 
        console.error(err)
    }
  };

  handlePaymentChange(key) {
    const value = this.paymentGatewayTypes[key];
    this.setState({ showMpgs: value === "MPGS", paymentGateway: value });
  }

  handleMerchantTypeChange(key) {
    const value = this.state.merchantTypes[key];
    this.setState({ selectedMerchantType: value });
  }

  handlePaymentConfig(key, event) {
    this.setState({ [key]: event.target.value });
  }

  onAllCriteria = () => {
    this.setState({
      allCriteria: !this.state.allCriteria,
      firstName: !this.state.allCriteria,
      lastName: !this.state.allCriteria,
      phoneNumber: !this.state.allCriteria,
      parentID: !this.state.allCriteria,
      studentID: !this.state.allCriteria,
      emailID1: !this.state.allCriteria,
    });
  };

  onToggleGradeUpdate = (e) => {
    if (
      this.adminType === ADMIN_TYPE.SALESADMIN ||
      this.state.schoolDataProvided
    )
      return;
    this.setState({
      isGradeUpdate: !this.state.isGradeUpdate,
      showConfirmation: true,
    });
  };

  onCheckAllCriteria = () => {
    let allValue = false;
    allValue =
      this.state.firstName &&
      this.state.lastName &&
      this.state.phoneNumber &&
      this.state.parentID &&
      this.state.studentID &&
      this.state.emailID1;
    this.setState({ allCriteria: allValue });
  };

  onConfirmationYes = () => {
    const msg = this.state.isGradeUpdate
      ? this.snackMsg.gradeEnabled
      : this.snackMsg.gradeDisabled;
    this.setState({ snackMsg: msg }, this.onSaveStudentConfig);
  };

  onConfirmationNo = () => {
    this.setState({
      isGradeUpdate: !this.state.isGradeUpdate,
      showConfirmation: false,
    });
  };

  onCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ showSnack: false, snackMsg: "" });
  };

  handleMerchantInputChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      merchantDetails: {
        ...prevState.merchantDetails,
        [name]: value,
      },
    }));
  };

  handleSecretInputChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      checkoutConfig: {
        ...prevState.checkoutConfig,
        [name]: value,
      },
    }));
  };

  handleOauthInputChange = (event) => {
    const { name, value } = event.target;
    const processedValue = name === "allowedScope" && value
      ? value.replace(/[\n\r]+/g, '')
      : value;
    
    this.setState((prevState) => ({
      oauthConfig: {
        ...prevState.oauthConfig,
        [name]: processedValue,
      },
    }));
  };

  handleConvenienceFeeInputChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      convenienceFeeConfig: {
        ...prevState.convenienceFeeConfig,
        [name]: value,
      },
    }));
  };

  handleConvenienceFeeTypeChange(key) {
    this.setState((prevState) => ({
      convenienceFeeConfig: {
        ...prevState.convenienceFeeConfig,
        feeType: this.state.convenienceFeeTypes[key],
      },
    }));
  }

  handleCheckoutPaymentTypesChange(key) {
    const { checkoutConfig } = this.state;
    const paymentMethods = Array.isArray(checkoutConfig?.paymentMethods) 
      ? checkoutConfig.paymentMethods 
      : [];
    
    if (paymentMethods.includes(key)) {
      this.setState({
        checkoutConfig: {
          ...this.state.checkoutConfig,
          paymentMethods: paymentMethods.filter(
            (method) => method !== key
          ),
        },
      });
    } else {
      this.setState({
        checkoutConfig: {
          ...this.state.checkoutConfig,
          paymentMethods: [...paymentMethods, key],
        },
      });
    }
  }

  toggleConvenienceFeeEnabled() {
    this.setState((prevState) => ({
      convenienceFeeConfig: {
        ...prevState.convenienceFeeConfig,
        enabled: !prevState.convenienceFeeConfig.enabled,
      },
    }));
  }

  toggleWebCheckoutEnabled() {
    this.setState((prevState) => ({
      checkoutConfig: {
        ...prevState.checkoutConfig,
        enabled: !prevState.checkoutConfig.enabled,
      },
    }));
  }

  toggleWebCheckoutOttChallengeEnabled() {
    this.setState((prevState) => ({
      checkoutConfig: {
        ...prevState.checkoutConfig,
        ottChallengeEnabled: !prevState.checkoutConfig.ottChallengeEnabled,
      },
    }));
  }

  toggleOAuthConfigurationEnabled() {
    this.setState((prevState) => ({
      oauthConfig: {
        ...prevState.oauthConfig,
        enabled: !prevState.oauthConfig.enabled,
      },
    }));
  } 

  renderGeneral() {
    return (
      <div style={{ borderBottom: BORDER_PRIMARY }}>
        {this.state.isFetching ? (
          <div className="configuration-general">
            <Skeleton variant="text" width={100} />
            <Skeleton
              variant="rectangle"
              width={400}
              height={250}
              sx={{ marginTop: 2 }}
            />
          </div>
        ) : (
          <div className="configuration-general">
            <Typography variant="h5" className="mb-4">
              General
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: colors.custom, textAlign: TEXT_ALIGN_LEFT }}
              className="mb-3"
            >
              Please specify the type of integration with QKR
            </Typography>

            <div className="d-flex flex-column mb-4">
              <CustomRadioButton
                label="Integrated"
                isChecked={this.state.schoolDataProvided}
                disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                onClick={() =>
                  this.setState({
                    schoolDataProvided: true,
                    isGradeUpdate: false,
                    DisableOutstandingFee: false,
                  })
                }
              />
              <CustomRadioButton
                label="Non-Integrated"
                isChecked={!this.state.schoolDataProvided}
                disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                onClick={() =>
                  this.setState({
                    schoolDataProvided: false,
                    DisableOutstandingFee: true,
                    outstandingFee: false,
                    partialPaymentAllowed: false,
                    updateOutstandingFeeBalance: false,
                  })
                }
              />
            </div>
            <Typography
              variant="body1"
              sx={{ color: colors.custom, textAlign: TEXT_ALIGN_LEFT }}
              className="mb-3"
            >
              {STUDENT_CONFIG_CONSTANTS.AUTH_METHODS}
            </Typography>
            <div className="d-flex flex-column mb-4">
              <div style={{ width: 220, height: 40 }}>
                <CustomCheckbox
                  label="OTP authentication"
                  isChecked={this.state.isCheckedOTP}
                  disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                  onChange={() =>
                    this.setState({ isCheckedOTP: !this.state.isCheckedOTP })
                  }
                />
              </div>
              <div style={{ width: 220, height: 40 }}>
                <CustomCheckbox
                  label="3D Security"
                  isChecked={this.state.secure3dEnabled}
                  disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                  onChange={() =>
                    this.setState({
                      secure3dEnabled: !this.state.secure3dEnabled,
                    })
                  }
                />
              </div>
            </div>
            <Typography
              variant="body1"
              sx={{ color: colors.custom, textAlign: TEXT_ALIGN_LEFT }}
              className="mb-3"
            >
              {STUDENT_CONFIG_CONSTANTS.ENABLE_OUTSTANDING}
            </Typography>
            <div className="d-flex flex-column mb-4">
              <CustomRadioButton
                label="Yes"
                isChecked={this.state.outstandingFee}
                disabled={
                  this.adminType === ADMIN_TYPE.SALESADMIN ||
                  this.state.DisableOutstandingFee ||
                  !this.state.schoolDataProvided
                }
                onClick={() => this.setState({ outstandingFee: true })}
              />
              <div style={{ width: 30 }} />
              <CustomRadioButton
                label="No"
                isChecked={!this.state.outstandingFee}
                disabled={
                  this.adminType === ADMIN_TYPE.SALESADMIN ||
                  this.state.DisableOutstandingFee ||
                  !this.state.schoolDataProvided
                }
                onClick={() =>
                  this.setState({
                    outstandingFee: false,
                    partialPaymentAllowed: false,
                    updateOutstandingFeeBalance: false,
                  })
                }
              />
            </div>
            <Typography
              variant="body1"
              sx={{ color: colors.custom, textAlign: TEXT_ALIGN_LEFT }}
              className="mb-3"
            >
              {STUDENT_CONFIG_CONSTANTS.UPDATE_OUTSTANDING}
            </Typography>
            <div className="d-flex flex-column mb-4">
              <CustomRadioButton
                label="Yes"
                isChecked={this.state.updateOutstandingFeeBalance}
                disabled={
                  this.adminType === ADMIN_TYPE.SALESADMIN ||
                  this.state.DisableOutstandingFee ||
                  !this.state.outstandingFee ||
                  !this.state.schoolDataProvided
                }
                onClick={() =>
                  this.setState({ updateOutstandingFeeBalance: true })
                }
              />
              <CustomRadioButton
                label="No"
                isChecked={!this.state.updateOutstandingFeeBalance}
                disabled={
                  this.adminType === ADMIN_TYPE.SALESADMIN ||
                  this.state.DisableOutstandingFee ||
                  !this.state.outstandingFee ||
                  !this.state.schoolDataProvided
                }
                onClick={() =>
                  this.setState({
                    updateOutstandingFeeBalance: false,
                  })
                }
              />
            </div>
            <CustomCheckbox
              label={STUDENT_CONFIG_CONSTANTS.ALLOW_PARTIAL_PAYMENT}
              isChecked={this.state.partialPaymentAllowed}
              disabled={
                this.state.showSchoolAdmin ||
                !this.state.outstandingFee ||
                this.adminType === ADMIN_TYPE.SALESADMIN ||
                this.state.DisableOutstandingFee
              }
              onChange={() =>
                this.setState({
                  partialPaymentAllowed: !this.state.partialPaymentAllowed,
                })
              }
            />
          </div>
        )}
      </div>
    );
  }

  renderTooltip(props) {
    return (
      <Tooltip id="button-tooltip" className="tooltip-text" {...props}>
        <div className="Tooltip-content-heading">
          {STUDENT_CONFIG_CONSTANTS.TOOLIP_HEADER1}
        </div>
        <div className="Tooltip-content">
          {STUDENT_CONFIG_CONSTANTS.TOOLIP_CONTENT1}
        </div>
        <br></br>
        <div className="Tooltip-content-heading">
          {STUDENT_CONFIG_CONSTANTS.TOOLIP_HEADER2}
        </div>
        <div className="Tooltip-content">
          {STUDENT_CONFIG_CONSTANTS.TOOLIP_CONTENT2}
        </div>
        <br></br>
        <div className="Tooltip-content-heading">
          {STUDENT_CONFIG_CONSTANTS.TOOLTIP_HEADER3}
        </div>
        <div className="Tooltip-content">
          {STUDENT_CONFIG_CONSTANTS.TOOLTIP_CONTENT3}
        </div>
      </Tooltip>
    );
  }
  validateMerchantDetails = () => {
    const { merchantDetails } = this.state;
    let errorMessages = [];

    if (!merchantDetails.address1)
      errorMessages.push(STUDENT_CONFIG_CONSTANTS.ADDRESS_REQUIRED);
    if (
      merchantDetails.phone &&
      !/^[\+]?[0-9-\s]{7,16}$/.test(merchantDetails.phone)
    )
      errorMessages.push(STUDENT_CONFIG_CONSTANTS.INVALID_PHONE_NUMBER);
    if (!merchantDetails.primaryContactFirstName)
      errorMessages.push(STUDENT_CONFIG_CONSTANTS.FIRSTNAME_REQUIRED);
    if (!merchantDetails.primaryLegalName)
      errorMessages.push(STUDENT_CONFIG_CONSTANTS.LEGALNAME_REQUIRED);
    if (
      !merchantDetails.countryCode ||
      merchantDetails.countryCode.length !== 2
    )
      errorMessages.push(STUDENT_CONFIG_CONSTANTS.COUNTRY_CODE_REQUIRED);
    if (!merchantDetails.primaryWebsiteURL)
      errorMessages.push(STUDENT_CONFIG_CONSTANTS.PRIMARY_WEB_REQUIRED);

    return errorMessages;
  };

  renderGradeUpdate() {
    return (
      <div style={{ borderBottom: BORDER_PRIMARY }}>
        {this.state.isFetching ? (
          <div className="configuration-general">
            <Skeleton variant="text" width={200} />
            <Skeleton
              variant="rectangle"
              width={450}
              height={100}
              sx={{ marginTop: 2 }}
            />
          </div>
        ) : (
          <div className="configuration-general">
            <Typography variant="h5" className="mb-4">
              <div className="d-flex align-items-center justify-content-between">
                <span>{STUDENT_CONFIG_CONSTANTS.GRADE_HEADER}</span>
                <OverlayTrigger
                  trigger="hover"
                  placement="bottom"
                  delay={{ show: 250 }}
                  overlay={this.renderTooltip}
                >
                  <span>
                    <InfoIconLogo />
                  </span>
                </OverlayTrigger>
              </div>
            </Typography>

            <ToggleButton
              label={STUDENT_CONFIG_CONSTANTS.GRADE_TOGGLE}
              isChecked={this.state.isGradeUpdate}
              disabled={
                this.adminType === ADMIN_TYPE.SALESADMIN ||
                this.state.schoolDataProvided
              }
              onClick={this.onToggleGradeUpdate}
            />
            <div style={{ height: 8 }} />
            {this.state.schoolDataProvided && (
              <UploadSuccessMsg
                msg={STUDENT_CONFIG_CONSTANTS.GRADE_SUCCESS_MSG}
              />
            )}
            {this.state.isGradeUpdate && this.state.gradeRequestedBy && (
              <div className="configuration-grade-box">
                <div className="d-flex flex-row gap-2">
                  <PrimarySuccessLogo />
                  <div>
                    <Typography variant="h4" sx={{ color: colors.custom }}>
                      {STUDENT_CONFIG_CONSTANTS.ENABLE_STUDENT_GRADE}
                    </Typography>
                    <Typography variant="h4" sx={{ color: colors.grayLight }}>
                      {`by ${this.state.gradeRequestedBy
                        },  ${uploadStatusDateFormat(
                          this.state.gradeRequestCreatedAt
                        )}`}
                    </Typography>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  renderSearchCriteria() {
    return (
      <div style={{ borderBottom: BORDER_PRIMARY }}>
        {this.state.isFetching ? (
          <div className="configuration-general">
            <Skeleton variant="text" width={150} />
            <Skeleton
              variant="rectangle"
              width={400}
              height={200}
              sx={{ marginTop: 2 }}
            />
          </div>
        ) : (
          <div className="configuration-general">
            <Typography variant="h5" className="mb-4">
              {STUDENT_CONFIG_CONSTANTS.SEARCH_CRITERIA_HEADER}
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: colors.custom, textAlign: TEXT_ALIGN_LEFT }}
              className="mb-3"
            >
              {STUDENT_CONFIG_CONSTANTS.SEARCH_CRITERIA_HEADER_TEXT}
            </Typography>
            <div
              className="d-flex flex-wrap"
              style={{ width: 500, marginTop: 8 }}
            >
              <div style={{ width: 150, height: 40 }}>
                <CustomCheckbox
                  label="First Name"
                  isChecked={this.state.firstName}
                  disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                  onChange={() =>
                    this.setState({ firstName: !this.state.firstName }, () =>
                      this.onCheckAllCriteria()
                    )
                  }
                />
              </div>
              <div style={{ width: 150, height: 40 }}>
                <CustomCheckbox
                  label="Last Name"
                  isChecked={this.state.lastName}
                  disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                  onChange={() =>
                    this.setState({ lastName: !this.state.lastName }, () =>
                      this.onCheckAllCriteria()
                    )
                  }
                />
              </div>
              <div style={{ width: 150, height: 40 }}>
                <CustomCheckbox
                  label="Parent ID"
                  isChecked={this.state.parentID}
                  disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                  onChange={() =>
                    this.setState({ parentID: !this.state.parentID }, () =>
                      this.onCheckAllCriteria()
                    )
                  }
                />
              </div>
              <div style={{ width: 150, height: 40 }}>
                <CustomCheckbox
                  label="Student ID"
                  isChecked={this.state.studentID}
                  disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                  onChange={() =>
                    this.setState({ studentID: !this.state.studentID }, () =>
                      this.onCheckAllCriteria()
                    )
                  }
                />
              </div>
              <div style={{ width: 150, height: 40 }}>
                <CustomCheckbox
                  label="Phone Number"
                  isChecked={this.state.phoneNumber}
                  disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                  onChange={() =>
                    this.setState(
                      { phoneNumber: !this.state.phoneNumber },
                      () => this.onCheckAllCriteria()
                    )
                  }
                />
              </div>
              <div style={{ width: 150, height: 40 }}>
                <CustomCheckbox
                  label="Email ID"
                  isChecked={this.state.emailID1}
                  disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                  onChange={() =>
                    this.setState({ emailID1: !this.state.emailID1 }, () =>
                      this.onCheckAllCriteria()
                    )
                  }
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderEppDetails = () => {
    const { eppConfigs } = this.state;
    let showEppForm = true;

    if (
      !eppConfigs ||
      typeof eppConfigs !== "object" ||
      Object.keys(eppConfigs).length === 0
    ) {
      showEppForm = false;
    }
    return (
      <div style={{ borderBottom: BORDER_PRIMARY }}>
        {this.state.isFetching ? (
          <div className="configuration-general">
            <Skeleton variant="text" width={150} />
            <Skeleton
              variant="rectangle"
              width={400}
              height={200}
              sx={{ marginTop: 2 }}
            />
          </div>
        ) : (
          <div className="configuration-general">
            <Typography variant="h5" className="mb-4">
              {STUDENT_CONFIG_CONSTANTS.EPP_HEADER}
            </Typography>
            {!showEppForm ? (
              <div style={{ margin: 24, marginTop: 0 }}>
                {STUDENT_CONFIG_CONSTANTS.NO_EPP_HEADER}
              </div>
            ) : (
              <div
                className="d-flex flex-wrap"
                style={{ width: 500, marginTop: 8 }}
              >
                {Object.keys(eppConfigs).map((provider, index) => (
                  <div
                    key={index}
                    style={{ width: "200px", marginRight: "20px" }}
                    className="eppConfigContainer"
                  >
                    <div>{provider.toUpperCase()}</div>
                    <div>
                      <ToggleButton
                        label={
                          eppConfigs[provider].enabled ? "Enabled" : "Disabled"
                        }
                        isChecked={eppConfigs[provider].enabled}
                        onClick={() => this.toggleEppEnabled(provider)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  toggleEppEnabled = (provider) => {
    this.setState((prevState) => ({
      eppConfigs: {
        ...prevState.eppConfigs,
        [provider]: {
          ...prevState.eppConfigs[provider],
          enabled: !prevState.eppConfigs[provider].enabled,
        },
      },
    }));
  };

  renderPayment() {
    return (
      <div style={{ borderBottom: BORDER_PRIMARY }}>
        {this.state.isFetching ? (
          <div className="configuration-general">
            <Skeleton variant="text" width={100} />
            <Skeleton
              variant="rectangle"
              width={600}
              height={300}
              sx={{ marginTop: 2 }}
            />
          </div>
        ) : (
          <div className="configuration-general">
            <Typography variant="h5" className="mb-4">
              {STUDENT_CONFIG_CONSTANTS.PAYMENT_SETTINGS}
            </Typography>
            {this.state.showMpgs ? (
              <div className="d-flex flex-wrap">
                <div className="config-payment-item">
                  <CustomDropdown
                    label="Payment Gateway"
                    value={this.state.paymentGateway}
                    width={376}
                    items={this.paymentGatewayTypes}
                    disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                    onChange={this.handlePaymentChange.bind(this)}
                  />
                </div>
                <div className="config-payment-item">
                  <TextInput
                    label="Apple MID"
                    value={this.state.appleMechantIdMpgs}
                    disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                    onChange={this.handlePaymentConfig.bind(
                      this,
                      "appleMechantIdMpgs"
                    )}
                    style={{ width: 376 }}
                  />
                </div>
                <div className="config-payment-item">
                  <TextInput
                    label="MPGS MID"
                    value={this.state.merchantIdMpgs}
                    disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                    onChange={this.handlePaymentConfig.bind(
                      this,
                      "merchantIdMpgs"
                    )}
                    style={{ width: 376 }}
                  />
                </div>
                <div className="config-payment-item">
                  <TextInput
                    label="Merchant OID"
                    value={this.state.merchantOid}
                    disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                    onChange={this.handlePaymentConfig.bind(
                      this,
                      "merchantOid"
                    )}
                    style={{ width: 376 }}
                  />
                </div>
                {this.adminType === ADMIN_TYPE.SUPERADMIN && (
                  <div className="config-payment-item">
                    <TextInput
                      label="Username"
                      value={this.state.username}
                      onChange={this.handlePaymentConfig.bind(this, "username")}
                      style={{ width: 376 }}
                    />
                  </div>
                )}

                {this.adminType === ADMIN_TYPE.SUPERADMIN && (
                  <div className="config-payment-item">
                    <TextInput
                      label="API Key"
                      value={this.state.password}
                      onChange={this.handlePaymentConfig.bind(this, "password")}
                      style={{ width: 376 }}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div className="d-flex flex-wrap">
                <div className="config-payment-item">
                  <CustomDropdown
                    label="Payment Gateway"
                    value={this.state.paymentGateway}
                    width={376}
                    items={this.paymentGatewayTypes}
                    disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                    onChange={this.handlePaymentChange.bind(this)}
                  />
                </div>
                <div className="config-payment-item">
                  <TextInput
                    label="Access Code"
                    value={this.state.accessCode}
                    onChange={this.handlePaymentConfig.bind(this, "accessCode")}
                    disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                    style={{ width: 376 }}
                  />
                </div>
                <div className="config-payment-item">
                  <TextInput
                    label="Merchant Identifier"
                    value={this.state.merchantIdentifier}
                    onChange={this.handlePaymentConfig.bind(
                      this,
                      "merchantIdentifier"
                    )}
                    disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                    style={{ width: 376 }}
                  />
                </div>
                <div className="config-payment-item">
                  <TextInput
                    label="SHA- Request Phrase"
                    value={this.state.shaRequestPhrase}
                    onChange={this.handlePaymentConfig.bind(
                      this,
                      "shaRequestPhrase"
                    )}
                    disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                    style={{ width: 376 }}
                  />
                </div>
                <div className="config-payment-item">
                  <TextInput
                    label="SHA- Response Phrase"
                    value={this.state.shaResponsePhrase}
                    onChange={this.handlePaymentConfig.bind(
                      this,
                      "shaResponsePhrase"
                    )}
                    disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                    style={{ width: 376 }}
                  />
                </div>
                <div className="config-payment-item">
                  <TextInput
                    label="Hash Algorithm"
                    value={this.state.hashingFunction}
                    onChange={this.handlePaymentConfig.bind(
                      this,
                      "hashingFunction"
                    )}
                    disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                    style={{ width: 376 }}
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  renderMerchantDetailsForm() {
    const { merchantDetails } = this.state;
    if (!merchantDetails) return null;
    return (
      <div style={{ borderBottom: BORDER_PRIMARY }}>
        {this.state.isFetching ? (
          <div className="configuration-general">
            <Skeleton variant="text" width={150} />
            <Skeleton
              variant="rectangle"
              width={400}
              height={200}
              sx={{ marginTop: 2 }}
            />
          </div>
        ) : (
          <div className="configuration-general">
            <Typography variant="h5" className="mb-4">
              Merchant Details
            </Typography>
            <div className="d-flex flex-wrap" style={{ marginTop: 8 }}>
              {Object.entries(merchantDetails).map(([key, value]) => (
                <div className="config-payment-item" key={key}>
                  <TextInput
                    label={key
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase())}
                    value={value}
                    onChange={this.handleMerchantInputChange}
                    name={key}
                    style={{ width: 376 }}
                    disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }

   renderSecretDetailsForm() {
    const { checkoutConfig } = this.state;

    if (!checkoutConfig) return null;
    if (!this.adminType === ADMIN_TYPE.SUPERADMIN) return null;
    return (
      <div style={{ borderBottom: BORDER_PRIMARY }}>
        {this.state.isFetching ? (
          <div className="configuration-general">
            <Skeleton variant="text" width={150} />
            <Skeleton
              variant="rectangle"
              width={400}
              height={200}
              sx={{ marginTop: 2 }}
            />
          </div>
        ) : (
          <div className="configuration-general">
            <Typography variant="h5" className="mb-4">
              {STUDENT_CONFIG_CONSTANTS.WEB_CHECKOUT}
            </Typography>
            <div className="d-flex flex-wrap" style={{ marginTop: 8 }}>
              <div>
                <ToggleButton
                  label={
                    this.state.checkoutConfig?.enabled
                      ? "Enabled"
                      : "Disabled"
                  }
                  isChecked={this.state.checkoutConfig?.enabled}
                  onClick={() => this.toggleWebCheckoutEnabled()}
                />
              </div>
            </div>
            {checkoutConfig.enabled && (
              <div style={{ marginTop: 0 }}>
                <div className="d-flex flex-wrap mt-2">

                   {Object.entries(checkoutConfig)
                    .filter(([key]) => key === 'systemId' || key === 'webhookURL')
                    .map(([key, value]) => (
                <div className="config-payment-item" key={key}>
                  <TextInput
                    label={key
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase())}
                    value={value}
                    onChange={this.handleSecretInputChange}
                    name={key}
                    style={{ width: 376 }}
                    disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                  />
                </div>
              ))}

<div style={{ marginTop: 0 }}>
            <Typography
              variant="body1"
              sx={{ color: colors.custom, textAlign: TEXT_ALIGN_LEFT }}
              className="mb-3"
            >
              {STUDENT_CONFIG_CONSTANTS.WEB_CHECKOUT_PAYMENT_METHOD_HEADER}
            </Typography>
            <div
              className="d-flex flex-wrap"
              style={{ width: 500, marginTop: 8 }}
            >

              {this.state.checkoutConfigPaymentypes.map((key) => (
                <div style={{ width: 150, height: 40 }} key={key}>
                  <CustomCheckbox
                  label={key}
                  isChecked={Array.isArray(checkoutConfig?.paymentMethods) && checkoutConfig.paymentMethods.includes(key)}
                  disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                  onChange={() => this.handleCheckoutPaymentTypesChange(key)}
                />
                </div>
              ))}

            </div>
          </div>

                </div>
              </div>
            )}

            <Typography variant="h5" className="mb-4" style={{ marginTop: 16 }}>
              {STUDENT_CONFIG_CONSTANTS.OTT_CHALLENGE}
            </Typography>
            <div className="d-flex flex-wrap" style={{ marginTop: 8 }}>
              <div>
                <ToggleButton
                  label={
                    this.state.checkoutConfig?.ottChallengeEnabled
                      ? "Enabled"
                      : "Disabled"
                  }
                  isChecked={this.state.checkoutConfig?.ottChallengeEnabled}
                  onClick={() => this.toggleWebCheckoutOttChallengeEnabled()}
                />
              </div>
            </div>

            {checkoutConfig.ottChallengeEnabled && (
              <div style={{ marginTop: 0 }}>
                <div className="d-flex flex-wrap mt-2">

                   {Object.entries(checkoutConfig)
                    .filter(([key]) => key === 'ottChallengeSalt')
                    .map(([key, value]) => (
                <div className="config-payment-item" key={key}>
                  <TextInput
                    label={key
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase())}
                    value={value}
                    onChange={this.handleSecretInputChange}
                    name={key}
                    style={{ width: 376 }}
                    disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                  />
                </div>
              ))}

                </div>
              </div>
            )}
            
          </div>
        )}
      </div>
    );
  }



   renderOauthConfigDetailsForm() {
    const { oauthConfig } = this.state;
    const isMsgError = oauthConfig.allowedScope?.length > MESSAGE_MAX_LEN;
    if (!oauthConfig) return null;
    if (!this.adminType === ADMIN_TYPE.SUPERADMIN) return null;
    return (
      <div style={{ borderBottom: BORDER_PRIMARY }}>
        {this.state.isFetching ? (
          <div className="configuration-general">
            <Skeleton variant="text" width={150} />
            <Skeleton
              variant="rectangle"
              width={400}
              height={200}
              sx={{ marginTop: 2 }}
            />
          </div>
        ) : (
          <div className="configuration-general">
               <Typography variant="h5" className="mb-4" style={{ marginTop: 16 }}>
              {STUDENT_CONFIG_CONSTANTS.OAUTH_CONFIGURATION}
            </Typography>
            <div className="d-flex flex-wrap" style={{ marginTop: 8 }}>
              <div>
                <ToggleButton
                  label={
                    this.state.oauthConfig?.enabled
                      ? "Enabled"
                      : "Disabled"
                  }
                  isChecked={this.state.oauthConfig?.enabled}
                  onClick={() => this.toggleOAuthConfigurationEnabled()}
                />
              </div>
            </div>

            {oauthConfig.enabled && (
              <div style={{ marginTop: 0 }}>
                <div className="d-flex flex-wrap mt-2">

                   {Object.entries(oauthConfig)
                    .filter(([key]) => key === 'clientId' || key === 'clientSecret')
                    .map(([key, value]) => (
                <div className="config-payment-item" key={key}>
                  <TextInput
                    label={key
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase())}
                    value={value}
                    onChange={this.handleOauthInputChange}
                    name={key}
                    style={{ width: 376 }}
                    disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                  />
                </div>
              ))}

                </div>

                 <div 
                className="config-payment-item"
                style={{ marginBottom: 8,marginRight:24 }}
                 >
                  
          <TextInput
            multiline
            label="Allowed Scope"
            name="allowedScope"
            type="text"
            rows={10}
            disabled={this.adminRole == ADMIN_TYPE.SALESADMIN}
            style={{ width: "100%",maxWidth:776 }}
            error={isMsgError}
            maxLength={MESSAGE_MAX_LEN}
            value={this.state.oauthConfig.allowedScope}
            onChange={this.handleOauthInputChange}
          />
          <Typography
            variant="h4"
            sx={{
              color: colors.grayLight,
              marginTop: "-20px",
              textAlign: TEXT_ALIGN_RIGHT,
              paddingRight: 1,
            }}
          >
            {this.state.oauthConfig?.allowedScope?.length} /{MESSAGE_MAX_LEN}
          </Typography>
        
        </div>

              </div>
            )}

          
          </div>
        )}
      </div>
    );
  }

 

  renderConvenienceFeeConfigForm() {
    const { convenienceFeeConfig } = this.state;

    if (!convenienceFeeConfig) return null;
    if (!this.adminType === ADMIN_TYPE.SUPERADMIN) return null;
    return (
      <div style={{ borderBottom: BORDER_PRIMARY }}>
        {this.state.isFetching ? (
          <div className="configuration-general">
            <Skeleton variant="text" width={150} />
            <Skeleton
              variant="rectangle"
              width={400}
              height={200}
              sx={{ marginTop: 2 }}
            />
          </div>
        ) : (
          <div className="configuration-general">
            <Typography variant="h5" className="mb-4">
              {STUDENT_CONFIG_CONSTANTS.CONVIENCE_FEES}
            </Typography>
            <div className="d-flex flex-wrap" style={{ marginTop: 8 }}>
              <div>
                <ToggleButton
                  label={
                    this.state.convenienceFeeConfig?.enabled
                      ? "Enabled"
                      : "Disabled"
                  }
                  isChecked={this.state.convenienceFeeConfig?.enabled}
                  onClick={() => this.toggleConvenienceFeeEnabled()}
                />
              </div>
            </div>
            {convenienceFeeConfig.enabled && (
              <div style={{ marginTop: 0 }}>
                <div className="d-flex flex-wrap mt-2">
                  <div className="config-payment-item">
                    <TextInput
                      label="Convenience Fee Value"
                      type="number"
                      value={convenienceFeeConfig.value}
                      onChange={this.handleConvenienceFeeInputChange}
                      name="value"
                      style={{ width: 376 }}
                    />
                  </div>

                  <div className="config-payment-item">
                    <CustomDropdown
                      label="Convenience Fee Type"
                      value={this.state.convenienceFeeConfig?.feeType}
                      width={376}
                      items={this.state.convenienceFeeTypes}
                      onChange={this.handleConvenienceFeeTypeChange.bind(this)}
                    />
                  </div>

                  {this.state.convenienceFeeConfig?.feeType == "PERCENTAGE" && (
                    <div className="config-payment-item">
                      <TextInput
                        label="Maximum Amount"
                        type="number"
                        value={convenienceFeeConfig.maximumAmount}
                        onChange={this.handleConvenienceFeeInputChange}
                        name="maximumAmount"
                        style={{ width: 376 }}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  renderMerchantType() {
    return (
      <div style={{ borderBottom: BORDER_PRIMARY }}>
        {this.state.isFetching ? (
          <div className="configuration-general">
            <Skeleton variant="text" width={100} />
            <Skeleton
              variant="rectangle"
              width={600}
              height={300}
              sx={{ marginTop: 2 }}
            />
          </div>
        ) : (
          <div className="configuration-general">
            <Typography variant="h5" className="mb-4">
              {STUDENT_CONFIG_CONSTANTS.MERCHANT_TYPE}
            </Typography>

            <div className="d-flex flex-wrap">
              <div className="config-payment-item">
                <CustomDropdown
                  label="Merchant Type"
                  value={this.state.selectedMerchantType}
                  width={376}
                  items={this.state.merchantTypes}
                  disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
                  onChange={this.handleMerchantTypeChange.bind(this)}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderSaveBtn() {
    if (this.state.isFetching) {
      return (
        <div className="configuration-general">
          <Skeleton variant="text" width={100} height={32} />
        </div>
      );
    }
    return (
      <div className="configuration-general">
        <ButtonGroup className="d-flex flex-row justify-content-between gap-4">
          <SecondaryButton
            label={STUDENT_CONFIG_CONSTANTS.SECONDARY_BUTTON}
            onClick={() => this.context.navigateTo(ROUTES.STUDENT_DATA)}
            disabled={this.state.isSaving}
          />
          <PrimaryButton
            label={STUDENT_CONFIG_CONSTANTS.PRIMARY_BUTTON}
            onClick={() =>
              this.setState(
                { snackMsg: this.snackMsg.configSuccess },
                this.onSaveStudentConfig
              )
            }
            disabled={this.state.isSalesAdmin || this.state.isSaving}
            isLoading={this.state.isSaving}
          />
        </ButtonGroup>
      </div>
    );
  }

  render() {
    return (
      <StudentConfigStyled>
        <CustomBreadcrumb
          header={STUDENT_CONFIG_CONSTANTS.HEADER}
          currentPage={STUDENT_CONFIG_CONSTANTS.BREADCRUMB_CONFIGURATIONS}
        >
          <div className="configuration-page">
            {this.renderGeneral()}
            {this.renderGradeUpdate()}
            {this.renderSearchCriteria()}
            {this.renderPayment()}
            {this.renderMerchantType()}
            {this.renderEppDetails()}
            {this.renderMerchantDetailsForm()}
            {this.renderSecretDetailsForm()}
            {this.renderOauthConfigDetailsForm()}
            {this.renderConvenienceFeeConfigForm()}
            {this.renderSaveBtn()}
          </div>

          <SnackMsg
            show={this.state.showSnack}
            msg={this.state.snackMsg}
            onClose={this.onCloseSnack}
          />

          <ConfirmationPopUp
            show={this.state.showConfirmation}
            title={
              this.state.isGradeUpdate
                ? ENABLE_GRADE_HEADER
                : DISABLE_GRADE_HEADER
            }
            bodyMsg={
              this.state.isGradeUpdate ? ENABLE_GRADE_BODY : DISABLE_GRADE_BODY
            }
            isLoading={this.state.isSaving}
            onYes={this.onConfirmationYes}
            onNo={this.onConfirmationNo}
          />

          {this.state.sessionExpired ? (
            <SessionExpiredModal
              show={this.state.sessionExpired}
              onHide={this.sessionExpiredClose}
            />
          ) : null}
        </CustomBreadcrumb>
      </StudentConfigStyled>
    );
  }
}

export default StudentAppConfig;
